export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14257.1017985b.jpg";